import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { t } from "@/lib/i18n";
import { useSite } from "@/context/SiteContext";

export default function FaqList({ limit }) {
  const { content } = useSite();
  const faqs = (content.faqs || []).slice(0, limit || undefined);
  return (
    <Accordion type="single" collapsible className="space-y-3" data-testid="faq-list">
      {faqs.map((f, i) => (
        <AccordionItem key={t(f.q)} value={`f-${i}`} className="bg-white rounded-2xl border border-[rgba(20,40,26,.08)] px-5 data-[state=open]:border-[var(--leaf)]/40" data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left font-semibold text-base hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>{t(f.q)}</AccordionTrigger>
          <AccordionContent className="text-[var(--ink-soft)] leading-relaxed text-sm sm:text-base pb-5">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
